import { useContext, useEffect, useRef } from "react";
import { MapContext } from "../../../../helpers";

type AlignOriginHandleProps = {
    position: google.maps.LatLngLiteral;
    onDrag: (latLng: google.maps.LatLng) => void;
    onDragEnd: (latLng: google.maps.LatLng) => void;
};

export const AlignOriginHandle: React.FC<AlignOriginHandleProps> = ({ position, onDrag, onDragEnd }) => {
    const [parentMap] = useContext(MapContext);
    const marker = useRef<google.maps.marker.AdvancedMarkerElement>();
    const onDragRef = useRef(onDrag);
    onDragRef.current = onDrag;
    const onDragEndRef = useRef(onDragEnd);
    onDragEndRef.current = onDragEnd;

    useEffect(() => {
        if (!parentMap) return;

        const el = document.createElement("div");
        el.style.width = "20px";
        el.style.height = "20px";
        el.style.borderRadius = "50%";
        el.style.backgroundColor = "rgba(37, 99, 235, 0.95)";
        el.style.border = "3px solid #ffffff";
        el.style.boxShadow = "0 0 0 2px rgba(37, 99, 235, 0.5)";
        el.style.cursor = "grab";

        const m = new google.maps.marker.AdvancedMarkerElement({
            position,
            map: parentMap,
            content: el,
            gmpDraggable: true,
            zIndex: 10000,
        });
        marker.current = m;

        const startL = m.addListener("dragstart", () => {
            el.style.cursor = "grabbing";
        });
        const dragL = m.addListener("drag", (e: google.maps.MapMouseEvent) => {
            if (e.latLng) onDragRef.current(e.latLng);
        });
        const endL = m.addListener("dragend", (e: google.maps.MapMouseEvent) => {
            el.style.cursor = "grab";
            if (e.latLng) onDragEndRef.current(e.latLng);
        });

        return () => {
            startL.remove();
            dragL.remove();
            endL.remove();
            m.map = null;
            marker.current = undefined;
        };
    }, [parentMap]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (marker.current) marker.current.position = position;
    }, [position.lat, position.lng]);

    return null;
};
